module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/banner.a7bde710.png";